// Module
var code = `<div class="timeSales-panel">
    <div class="timeSales-panel-container-top">
         <terceraInstrumentLookup mayContainTrees="true" selectedItem="{{instrument}}" selectedAccount="{{account}}" /> 
    </div>

    <div class="timeSales-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;